import { iItemProps, Item } from '@/Engine/Item';
export const alphaAnimateDoor = Math.PI / 12;
export const alphaOpenHalfDoor = 2.5 * Math.PI / 4;
export const alphaCloseDoor = 0;
export class Door extends Item {
    isLeft: boolean;
    isCloseDoors = false;
    constructor(props: iItemProps, color: string, isLeft: boolean) {
        super(props);
        this.isLeft = isLeft;
    }
    //открытые двери призакрываем, закрытые приоткрываем
    openAtAngle(alpha: number) {
        if (this.isCloseDoors) {
            this.close(alpha);
        } else {
            this.openHalf(alpha);
        }

    }
    open() {
        this.yRotation(this.isLeft ? - Math.PI : Math.PI);
        this.isCloseDoors = false;
    }
    openHalf(alpha = 0) {
        this.yRotation(this.isLeft ? -alphaOpenHalfDoor-alpha : alphaOpenHalfDoor+alpha);
        this.isCloseDoors = false;
    }

    close(alpha = 0) {
        this.yRotation(this.isLeft ? -alphaCloseDoor-alpha : alphaCloseDoor+alpha);
        this.isCloseDoors = true;
    }
}
